<template>
  <section>
    <v-progress-circular
    v-if="loading"
    id="loading_spinner"
    indeterminate
    size=64
    color="primary"
    >
    </v-progress-circular>

    <div v-for="item in library" :key="item.request_id" class="item">
      <span>{{ item.result_type }} Painting created on {{ item.request_date }}</span>
        <br/>
        <display_painting :user="user" :watermark_visible="item.watermark_visible" :request_id="item.request_id" :full_result_url="full_result_url(item.file_location)" :api_prefix="api_prefix" @payment_processed="payment_processed"></display_painting>
    </div>
    
  </section>
</template>

<script>
import DisplayPainting from "@/components/DisplayPainting.vue";

export default {
    props: ['user','api_prefix'],
    data() {
        return {
            loading: false,
            displaying_demo_dashboard: false,
            library: [],
            uuid: null
        };
    },
    components: {
      'display_painting': DisplayPainting,
    },
    watch: 
    {
         
    },
    computed: {
      
    },
    methods: 
    {
      full_result_url(file_location)
      {
        return "https://s3.us-west-2.amazonaws.com/" + file_location
      },
      payment_processed(url, request_id)
      {
        this.result_url = url
        //iterate through the library, and update the matching request_id's file_location
        for (const item of self.library)
        {
          if(item.request_id==request_id)
          {
            item.file_location = url;
            console.log('updated file location of matching request_id in library')
            break
          }
        }
      },
      async get_data()
      {
        let self = this
        self.loading = true
        var response = await this.$http.get(this.api_prefix + '/library',
        {
          params: {
            'uuid': self.uuid
          }
        });
        self.loading = false

        if(response.data!=null)
        {
          //daily data in bar chart
          self.library = response.data
        }
      }
    },
    mounted() 
    {
      let self = this;

      analytics.track('Page Visited', 
      {
        title: 'Library',
      });

      var uuid = this.$route.params.uuid;
      if (uuid!=null)
      {
        self.uuid = uuid
      }

      self.get_data()
    }
};
</script>

<style scoped>
.item
{
  margin: 10px;
}
#logs
{
  background-color: black;
  color: white;
}
.centered
{
  text-align: center;
  display: block;
  background-color: transparent;
}
#loading_spinner
{
  margin: 0 auto;
  display: inherit;
}
#summary_stats_description
{
  font-style: italic;
  text-align: center;
}
.change_arrows
{
  height: 35px;
  width: 35px;
  vertical-align: middle;
}
.stat_cards
{
  text-align: center;
}
#summary_stats
{
  text-align: center;
}
</style>
